/**
 * Sincronización: primero lo que haya en el dispositivo (al instante), después el libro en segundo plano.
 * Solo se descarga si el fichero ha cambiado según Drive.
 */
import { parseWorkbook, type Workbook } from '@sut/workbook';
import type { CachedWorkbook, LocalCache, WorkbookSource } from './ports.js';

export interface Loaded { wb: Workbook; title: string; syncedAt: string; fromCache: boolean }

export const fromCached = (c: CachedWorkbook, fromCache = true): Loaded =>
  ({ wb: parseWorkbook(c.ranges), title: c.title, syncedAt: c.syncedAt, fromCache });

export async function loadCached(source: WorkbookSource, cache: LocalCache): Promise<Loaded | null> {
  const c = await cache.load(source.id);
  return c ? fromCached(c) : null;
}

/** @return los datos nuevos, o null si el libro no ha cambiado desde la última vez. */
export async function sync(source: WorkbookSource, cache: LocalCache, force = false): Promise<Loaded | null> {
  const cached = await cache.load(source.id);
  const { name, modifiedTime } = await source.meta();
  const now = new Date().toISOString();
  if (!force && cached && cached.modifiedTime === modifiedTime) {
    await cache.save({ ...cached, title: name, syncedAt: now });
    return null;
  }
  const value: CachedWorkbook = { sourceId: source.id, title: name, modifiedTime, ranges: await source.readData(), syncedAt: now };
  await cache.save(value);
  return fromCached(value, false);
}
